/**
 * Investment-data illustration from the design system, shown on the statement upload intro.
 *
 * Sized 150x88 by default, its natural aspect ratio. Rendered directly rather than through
 * SVGWrapper, which drives width and height off one size token and would distort it.
 */
function ArtInvestmentData(props) {
  return (
    <svg
      aria-hidden='true'
      viewBox='0 0 150 88'
      width='150'
      height='88'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <g fillRule='nonzero' fill='none'>
        <path fill='#F5FAFC' d='M0 48.761 85.255 0 150 37.923 65.468 88z' />
        <g transform='translate(73.074 7.664)'>
          <path
            d='M2.605 12.24c2.016 1.526 5 2.59 8.409 2.877.604.05 1.217.075 1.846.075 7.166 0 12.975-3.415 12.975-7.634 0-1.938-1.228-3.706-3.254-5.057'
            fill='#F8BA48'
          />
          <path
            d='M3.254 12.691C1.228 11.345 0 9.577 0 7.634 0 3.42 5.809 0 12.975 0c4.172 0 7.88 1.155 10.255 2.953'
            fill='#F8C75F'
          />
          <path
            d='M12.895 7.815 23.11 2.863c1.707 1.29 2.72 2.913 2.72 4.675 0 1.166-.444 2.275-1.243 3.265'
            fill='#1C7792'
          />
          <path
            d='M2.68 12.28c2.974-1.407 5.953-2.813 8.928-4.22l1.028.332-.115 6.83c-4.741.121-7.68-1.31-9.447-2.621-.115-.086-.225-.17-.334-.256'
            fill='#1F4B54'
          />
          <ellipse fill='#E9F4F5' cx='12.85' cy='6.971' rx='6.597' ry='3.671' />
        </g>
        <path
          d='m115.257 24.8 22.402 13.033c.35.22.713.14.798-.02.085-.161-.045-.508-.409-.688l-22.372-12.908c-.484-.21-.868-.25-.938-.125-.065.115.13.386.434.653M111.395 27.351l22.401 13.033c.35.221.714.14.799-.02.085-.16-.045-.507-.41-.688l-22.371-12.907c-.484-.211-.868-.251-.938-.126-.065.116.13.387.434.653M107.073 30.013l22.402 13.033c.349.22.713.14.798-.02.085-.161-.045-.508-.41-.688l-22.37-12.908c-.485-.21-.87-.25-.939-.125-.065.115.13.387.434.653M102.861 32.625l22.402 13.032c.35.221.713.141.798-.02.085-.16-.045-.507-.409-.688L103.28 32.042c-.484-.21-.868-.251-.938-.126-.065.116.13.387.434.653M63.013 16.147l57.065 33.202.574.351c.18.256.12.603-.105.764-.19.135-.47.115-.664-.056l-44.748-26.15-12.626-7.303c-.4-.21-.489-.638-.354-.829.12-.17.479-.226.793-.02M57.254 19.823l57.065 33.202.574.352c.18.256.12.602-.105.763-.19.136-.469.115-.664-.055L69.376 27.934 56.75 20.63c-.399-.21-.489-.637-.354-.828.12-.171.479-.226.793-.02M11.119 48.917 33.52 61.95c.35.22.714.14.799-.02.084-.161-.045-.508-.41-.689L11.538 48.334c-.484-.21-.869-.25-.938-.125-.065.115.13.386.434.653'
          fill='#0D222A'
        />
        <path fill='#1C7792' d='m19.577 45.647 3.883 2.02 5.364-3.702-3.628-2.024z' />
        <path fill='#BFBFBF' d='m24.892 48.53 3.548 2.07 7.74-4.943-3.648-1.717' />
        <path fill='#1C7792' d='m29.817 51.438 3.499 2.124 10.759-6.935-3.189-1.808' />
        <path fill='#BFBFBF' d='m34.898 54.411 3.503 2.125L49.16 49.6l-3.194-1.808' />
        <path
          fill='#1C7792'
          d='m44.903 60.167 3.997 2.23 27.956-19.1-5.19-2.597-27.541 19M58.192 68.026l3.798 2.25L85.724 55.33l-4.421-2.11'
        />
        <path
          fill='#BFBFBF'
          d='m64.565 72.346 4.457 2.646 27.83-17.598-5.184-2.486M51.43 63.883l4.457 2.652 27.831-17.603-5.185-2.486'
        />
        <g transform='translate(31.73 21.24)'>
          <path
            d='M25.833 13.364v6.017c.26.452.644 1.075 1.173 1.773 5.834 7.709 16.832 8.422 20.036 8.482 1.063.02 14.981.096 21.808-8.97.15-.2.275-.371.354-.487l-.174-7.754'
            fill='#595853'
          />
          <ellipse fill='#8B8B89' cx='47.417' cy='12.541' rx='21.608' ry='12.541' />
          <ellipse fill='#424240' cx='47.591' cy='12.063' rx='18.18' ry='10.185' />
          <ellipse fill='#636260' cx='47.202' cy='12.541' rx='18.18' ry='10.185' />
          <path
            d='m2.12 38.611 29.278-17.367c.414.086 2.02.462 3.203 1.999 1.158 1.497 1.148 3.104 1.133 3.54l-.05.603L6.116 44.311'
            fill='#61615F'
          />
          <ellipse
            fill='#51524E'
            transform='rotate(-39.88 4.007 41.73)'
            cx='4.007'
            cy='41.731'
            rx='2.061'
            ry='3.782'
          />
          <ellipse fill='#E9F4F5' cx='47.107' cy='14.313' rx='17.227' ry='8.412' />
        </g>
      </g>
    </svg>
  )
}

export default ArtInvestmentData
